var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bsh-datatable',{ref:"datatable",attrs:{"columns":_vm.columns,"buttons":_vm.buttons,"link":_vm.link,"actionFild":"","sorting":""},on:{"selectRow":_vm.show,"show":_vm.show,"nextEstagio":_vm.nextEstagio,"arquivar":_vm.arquivar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }